import React from "react";
import WhatsMattersNowCard from "./WhatsMattersNowCard";
import WSM_ICON_ROW1 from "../../../../../assets/img/alertSvgRed.svg";
import IMG_FILTER_LIST from "../../../../../assets/img/img-filter-list.svg";
/** MCP `get_design_context` — assets for node 1:4278 (What Still Matters). */
const WSM_ROW1_RIM = "http://localhost:3845/assets/d9f1505dcb34533a9eb75079c79e768e3259ed02.svg";
/** Figma 1:4290…1:4369 — five rows; right column “days open” badge per MCP. */
export const WHAT_STILL_MATTERS_DEFAULT_ROWS = [
    {
        id: "wsm-1",
        title: "Rosewood Manor",
        subtitle: "Serious Incident",
        time: "Owner: Samantha Peters, Ops Director",
        status: "",
        statusVariant: "daysOpen",
        daysOpenCount: "6",
        severity: "critical",
        rimSrc: WSM_ROW1_RIM,
        iconSrc: WSM_ICON_ROW1,
    },
    {
        id: "wsm-2",
        title: "Riverdale Clinic",
        subtitle: "Guard Wander",
        time: "Owner: Steven Glenn | Manager",
        status: "",
        statusVariant: "daysOpen",
        daysOpenCount: "6",
        severity: "moderate",
    },
    {
        id: "wsm-3",
        title: "Lakeside Hospital",
        subtitle: "Surgical Complication",
        time: "TRIGGERED 3H AGO",
        status: "",
        statusVariant: "daysOpen",
        daysOpenCount: "6",
        severity: "low",
    },
    {
        id: "wsm-4",
        title: "Lakeside Hospital",
        subtitle: "Surgical Complication",
        time: "TRIGGERED 3H AGO",
        status: "",
        statusVariant: "daysOpen",
        daysOpenCount: "6",
        severity: "low",
    },
    {
        id: "wsm-5",
        title: "Riverdale Clinic",
        subtitle: "Guard Wander",
        time: "Owner: Steven Glenn | Manager",
        status: "",
        statusVariant: "daysOpen",
        daysOpenCount: "6",
        severity: "moderate",
    },
];
/** Figma 1:4370 — filter row below list, above footer CTA. */
function WhatStillMattersFilterStrip() {
    return (React.createElement("div", { className: "whats-matters-now-card__filter-strip", "data-node-id": "1:4370", "data-name": "Container" },
        React.createElement("div", { className: "whats-matters-now-card__filter-strip-overlay", "aria-hidden": true }),
        React.createElement("div", { className: "whats-matters-now-card__filter-strip-inner" },
            React.createElement("div", { className: "whats-matters-now-card__filter-pill whats-matters-now-card__filter-pill--active", "data-node-id": "1:4371", "data-name": "HorizontalBorder" },
                React.createElement("span", { className: "whats-matters-now-card__filter-pill-icon", "data-node-id": "1:4372", "data-name": "SVG" },
                    React.createElement("img", { alt: "", className: "whats-matters-now-card__filter-pill-img", src: IMG_FILTER_LIST })),
                React.createElement("p", { className: "whats-matters-now-card__filter-pill-text", "data-node-id": "1:4374" }, "Oldest first")),
            React.createElement("div", { className: "whats-matters-now-card__filter-opt", "data-node-id": "1:4375", "data-name": "Container" },
                React.createElement("p", { className: "whats-matters-now-card__filter-opt-text", "data-node-id": "1:4376" }, "\u2191 Highest Severity")),
            React.createElement("div", { className: "whats-matters-now-card__filter-opt", "data-node-id": "1:4377", "data-name": "Container" },
                React.createElement("p", { className: "whats-matters-now-card__filter-opt-text", "data-node-id": "1:4378" }, "\u2022 By Home")),
            React.createElement("div", { className: "whats-matters-now-card__filter-opt", "data-node-id": "1:4379", "data-name": "Container" },
                React.createElement("p", { className: "whats-matters-now-card__filter-opt-text", "data-node-id": "1:4380" }, "\u2022 By Owner"))),
        React.createElement("div", { className: "whats-matters-now-card__filter-strip-inset-shadow", "aria-hidden": true })));
}
export const WHAT_STILL_MATTERS_CARD_DEFAULTS = {
    heading: "What Still Matters",
    sortLabel: "Sort by: Oldest first ▾",
    footerCtaLabel: "View all critical events",
};
/**
 * Figma 1:4278 — “What Still Matters”; reuses {@link WhatsMattersNowCard} with MCP-driven copy and assets.
 */
const WhatStillMattersCard = () => {
    return (React.createElement(WhatsMattersNowCard, { className: "whats-matters-now-card--what-still-matters", rootDataNodeId: "1:4278", heading: WHAT_STILL_MATTERS_CARD_DEFAULTS.heading, sortLabel: WHAT_STILL_MATTERS_CARD_DEFAULTS.sortLabel, 
        // toolbarCtaLabel={WHAT_STILL_MATTERS_CARD_DEFAULTS.toolbarCtaLabel}
        footerCtaLabel: WHAT_STILL_MATTERS_CARD_DEFAULTS.footerCtaLabel, rows: WHAT_STILL_MATTERS_DEFAULT_ROWS, stillmatters: true }));
};
export default WhatStillMattersCard;
